import React from "react";

const JsonLd = ({ data }) => {
  if (!data) return null;

  const entries = Array.isArray(data) ? data : [data];

  return (
    <>
      {entries.map((entry, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </>
  );
};

export default JsonLd;
